
import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import TextField from '../../../../framework/fields/TextField.vue';
import PercentageField from '../../../../framework/fields/PercentageField.vue';
import DateField from '../../../../framework/fields/DateField.vue';
import { sharedState } from '../../../../framework/state';
import { postResource } from '../../../../framework/client/resource';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import { VatRate } from '../../../../../common/application/model/VatRate';
import { successToast, errorToast } from '../../../service/toast_service';
import { isOverlappingVatRate } from '../../../service/vat_rate_service';

@Component({
    components: { PercentageField, TextField, DateField, ValidationObserver },
})
export default class AddVatRate extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.VAT_RATE;

    // State
    shared = sharedState;
    local = {
        row: {} as VatRate,
    };

    add() {
        this.saveResource(false);
    }

    addAndClose() {
        this.saveResource(true);
    }

    private async saveResource(goBack: boolean) {
        const row = {
            ...this.local.row,
            countryCode: 'fi',
        };

        const isValid = await isOverlappingVatRate(row);
        if (!isValid) {
            errorToast(this, 'message.overlappingVatRates');
            return;
        }

        try {
            const newVatRate = await postResource<VatRate>(this.resourceType, row);
            successToast(this, 'message.vatRateSaved');
            if (goBack) {
                this.back();
            } else {
                this.$router.replace(`/${this.resourceType}/${newVatRate.id}/edit`);
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
